import React from 'react';
import { MDSelectProps } from './MDSelect.props';
import CustomSelect from '../../../CustomSelect';

export const MDSelect = ({ value, options, handleChange, warning, id }: MDSelectProps) => {
  const selectOptions = options.map(option => ({ value: option, label: option }));

  return {
    forceComponent: true,
    component: (
      <CustomSelect
        id={`md-select-${id}`}
        onEmptyValue="None"
        value={value ?? ''}
        onChange={handleChange}
        autoFocus={false}
        usePortal
        options={selectOptions}
      />
    ),
  };
};
